import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { ArrowRight, Download } from "lucide-react";
import { generateProposalPDF } from "@/lib/pdfGenerator";
import { useT } from "@/lib/i18n";

export default function StickyCTA() {
  const { t } = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      const inContact = document.getElementById("contact")?.getBoundingClientRect();
      const beyondHero = y > window.innerHeight * 0.85;
      const overlapContact = inContact && inContact.top < window.innerHeight * 0.5;
      setVisible(beyondHero && !overlapContact);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="sticky-cta"
      className={`fixed bottom-5 left-1/2 -translate-x-1/2 z-40 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 pointer-events-none translate-y-3"
      }`}
    >
      <div className="bg-[#0A192F] text-[#F9F7F1] px-2 py-2 flex items-center gap-2 shadow-2xl border border-[#0A192F]">
        <span className="hidden sm:block font-mono text-[10px] uppercase tracking-widest text-[#D4AF37] pl-4 pr-2">
          {t("sticky.fund")}
        </span>
        <Button
          data-testid="sticky-pdf-btn"
          onClick={generateProposalPDF}
          variant="ghost"
          className="rounded-none h-10 text-[#F9F7F1] hover:bg-[#15243F] font-mono text-[11px] uppercase tracking-widest"
        >
          <Download className="h-3.5 w-3.5 mr-2" /> PDF
        </Button>
        <Button
          data-testid="sticky-schedule-btn"
          asChild
          className="rounded-none bg-[#8B0000] hover:bg-[#A41E1E] text-[#F9F7F1] h-10 font-mono text-[11px] uppercase tracking-widest"
        >
          <a href="#contact">
            {t("nav.schedule")} <ArrowRight className="ml-2 h-3.5 w-3.5" />
          </a>
        </Button>
      </div>
    </div>
  );
}
